// eslint-disable-next-line no-shadow
enum PaymentStatus {
  APPROVED,
  DISAPPROVED,
  AWAITING_PAYMENT,
  CANCELED,
  CANCELLATION_ANALYSIS,
}
export default PaymentStatus;
